import { observer, use$ } from '@legendapp/state/react';
import { state$ } from './state';
import { Login } from './components/Login';
import { Chrome } from './components/Chrome';
import { Explorer } from './components/Explorer';
import { NicheDetail } from './components/NicheDetail';
import { FunctionDetail } from './components/FunctionDetail';
import { AppProfile } from './components/AppProfile';
import { Agent } from './components/Agent';
import { EvidenceDrawer } from './components/EvidenceDrawer';

const GLOBAL_CSS = `
  *{box-sizing:border-box;}
  html,body{margin:0;padding:0;}
  body{font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;background:#f1f1f1;color:#303030;-webkit-font-smoothing:antialiased;}
  ::-webkit-scrollbar{width:10px;height:10px;}
  ::-webkit-scrollbar-thumb{background:#c9cccf;border-radius:6px;border:2px solid #f1f1f1;}
  ::-webkit-scrollbar-track{background:transparent;}
  @keyframes nl-drawer{from{transform:translateX(26px);}to{transform:translateX(0);}}
  @keyframes nl-fade{from{transform:translateY(4px);}to{transform:translateY(0);}}
  @keyframes nl-rise{from{transform:translateY(9px);}to{transform:translateY(0);}}
  @keyframes nl-shimmer{0%{background-position:-400px 0;}100%{background-position:400px 0;}}
  @keyframes nl-grow{from{transform:scaleX(1);}to{transform:scaleX(1);}}
`;

export const App = observer(function App() {
  const view = use$(state$.view);

  if (view === 'login') {
    return (
      <>
        <style>{GLOBAL_CSS}</style>
        <Login />
      </>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        fontFeatureSettings: "'ss01'",
      }}
    >
      <style>{GLOBAL_CSS}</style>
      <Chrome>
        {view === 'explorer' && <Explorer />}
        {view === 'niche' && <NicheDetail />}
        {view === 'function' && <FunctionDetail />}
        {view === 'app' && <AppProfile />}
        {view === 'agent' && <Agent />}
      </Chrome>
      <EvidenceDrawer />
    </div>
  );
});
